import React, { Component } from 'react';
import Navbar from '../HeaderComponents/Navbar';
import Home from './Home';
import DashBoard from './../DashBoard';
import MenuBar from './../HeaderComponents/MenuBar';
import withAuth from './../../auth_components/js/withAuth';

class Notice extends Component {
  render() {
    return (
      <div>
        <DashBoard history={this.props.history} user={this.props.user} />
        <MenuBar />
        <Home />
      </div>
    )
  }
}
export default withAuth(Notice);


// WEBPACK FOOTER //
// ./src/HomeComponents/Notice/Notice.js